import React, { useEffect, useState } from "react";
import LeftSideNav from "../../../Components/LeftSideNav";
import TopNavBar from "../../../Components/TopNavbar";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import { TableContainer } from "@mui/material";
import Paper from "@mui/material/Paper";
import TransporterForm from "./Controller/TransporterForm";
import Fonts from "../../../Config/Fonts";
import Colors from "../../../theme/Colors";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const AddTransport = () => {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const location = useLocation();

  let actionForm;
  let actionAddOrEditText;
  if (location?.state?.addForm) {
    actionForm = "addForm";
    actionAddOrEditText = "Add Transporter";
  } else if (location?.state?.editForm) {
    actionForm = "editForm";
    actionAddOrEditText = "Edit Transport";
  }
  useEffect(() => {
    setBreadcrumbs([
      {
        key: "1",
        // href: "/",
        text: "Master",
      },
      {
        key: "2",
        href: "/transport",
        text: "Transport",
      },
      {
        key: "3",
        // href: "/addManufactures",
        text: "Add Transport",
      },
    ]);
  }, []);
  //   const { userData } = useSelector((state) => state.user);
  return (
    <>
      <div style={mainContainer}>
        <LeftSideNav />

        <div style={leftNavContainer}>
          <div style={topBar}>
            
            <TopNavBar leftSideText= {actionAddOrEditText} />

            <div style={pageTitle}>{/* <h2></h2> */}</div>

            <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
          </div>

          <TableContainer component={Paper} style={tableContainer}>
            {/* <h1 style={mainHeadingStyle}>Personal Information</h1> */}
            {/* <hr /> */}
            <TransporterForm actionForm={actionForm} />
          </TableContainer>
        </div>
      </div>
    </>
  );
};

const mainContainer = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100vh",
  width: "100vw",
  overflowX: "hidden",
  overflowY: "hidden",
};

const leftNavContainer = {
  display: "grid",
  gridTemplateRows: "15% 80%",
  //   backgroundColor: "#F0F5FF",
  backgroundColor: "lightGray",
};

const topBar = {
  backgroundColor: "white",
  height: "7vh",
  width: "100%",
};

const pageTitle = {
  marginLeft: "30px",
  justifyContent: "flex-start",
  display: "flex",
};

const tableContainer = {
  width: "75vw",
  border: "1px solid #ccc",
  borderRadius: "15px",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  marginTop: "40px",
  paddingLeft: "20px",
  paddingRight: "20px",
  marginLeft: "30px",
};

const mainHeadingStyle = {
  fontSize: 16,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans,
  color: Colors.black,
  display: "flex",
  marginTop: "20px",
  marginBottom: "20px",
};
export default AddTransport;
